import React, {useCallback, useEffect, useRef} from 'react';
import {Badge, Button, Empty, List, notification, Popover, Typography} from 'antd';
import {InfoCircleOutlined, NotificationOutlined, ReloadOutlined} from '@ant-design/icons';
import useNewVersionAvailable from '../../hooks/useNewVersionAvailable';
import './HeaderNotification.scss';

const {Text} = Typography;

const HeaderNotification = () => {
    const [notificationApi, notificationContextHolder] = notification.useNotification();
    const updateNotificationShownRef = useRef(false);
    const updateAvailable = useNewVersionAvailable();

    const handleRefresh = useCallback(() => {
        window.location.reload();
    }, []);

    useEffect(() => {
        if (!updateAvailable || updateNotificationShownRef.current) {
            return;
        }

        updateNotificationShownRef.current = true;
        notificationApi.info({
            message: 'New version available',
            description: 'Refresh to use the latest changes.',
            placement: 'topRight',
            duration: 0,
            className: 'app-update-notification',
            icon: <InfoCircleOutlined/>,
            btn: (
                <Button type="primary" size="small" icon={<ReloadOutlined/>} onClick={handleRefresh}>
                    Refresh
                </Button>
            ),
        });
    }, [handleRefresh, notificationApi, updateAvailable]);

    const notificationItems = updateAvailable
        ? [
            {
                key: 'new-version',
                title: 'New version available',
                description: 'Refresh the page to use the latest deployed version.',
            },
        ]
        : [];

    const notificationContent = (
        <div className="header-notification-popover">
            {notificationItems.length > 0 ? (
                <List
                    dataSource={notificationItems}
                    renderItem={(item) => (
                        <List.Item
                            key={item.key}
                            actions={[
                                <Button
                                    key="refresh"
                                    type="primary"
                                    size="small"
                                    icon={<ReloadOutlined/>}
                                    onClick={handleRefresh}
                                >
                                    Refresh
                                </Button>,
                            ]}
                        >
                            <List.Item.Meta
                                title={<Text strong>{item.title}</Text>}
                                description={item.description}
                            />
                        </List.Item>
                    )}
                />
            ) : (
                <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="No notifications"
                />
            )}
        </div>
    );

    return (
        <>
            {notificationContextHolder}
            <Popover
                content={notificationContent}
                title="Notifications"
                trigger="click"
                placement="bottomRight"
            >
                <Badge count={notificationItems.length} size="small">
                    <Button
                        type="text"
                        shape="circle"
                        className="header-notification-button"
                        icon={<NotificationOutlined/>}
                    />
                </Badge>
            </Popover>
        </>
    );
};

export default HeaderNotification;
